export default class GetResultadoPersonalC3 {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal) {
    return await this.#repository.getAll(idPersonal)
  }
}
